<template>
  <div>
    <div class="mt-2">
      <naj-search-box
        :type-id="formFieldType.number"
        :placeholder="local.home.tabCommon.filterWithRequestCode"
        :search.sync="searchQuery.requestCode"
        @filterDataClicked="filterData()"
        @showFilterClicked="toggleFilter()"
      ></naj-search-box>
    </div>
    <div
      v-if="hasFilter"
      class="filter-row-wrapper d-flex mt-3"
    >
      <div class="col-12">
        <template v-for="filter in filters">
          <span
            v-if="searchQuery[filter.name]"
            :key="filter.name"
            class="ma-1"
          >
            <v-chip
              :key="filter.name"
              :input-value="searchQuery[filter.name]"
              color="#F7FBFB"
              close
              outlined
              @click:close="searchQuery[filter.name]=null ; filterData();"
            >
              <strong class="text-primary">{{ filter.label + ':' + (searchQuery[filter.name+'DisplayName'] || searchQuery[filter.name]) }}</strong>
            </v-chip>
          </span>
        </template>
      </div>
    </div>
    <v-row class="mt-7">
      <v-col :cols="showFilter?9:12">
        <naj-item-table
          :data-items="data.list"
          :headers="headers"
          :pagination="pagination"
          :loading="loading"
          :items-per-page="pagination.pageSize"
          :server-items-length="pagination.totalCount"
          @update:page="onPageChange"
          @expandSlot="getRequestReplies"
        >
          <template slot="expandButtonText">
            <div>
              <div class="text-center">
                {{ local.requestReply.reasons }}
              </div>
            </div>
          </template>
          <template
            slot="requestCode"
            slot-scope="{item}"
          >
            <div class="info-item-details-title">
              {{ local.home.tabCommon.requestCode }}
            </div>
            <div class="info-item-details-value mt-3">
              {{ item.requestCode }}
            </div>
          </template>
          <template
            v-if="hasDetails(item)"
            slot="expandSlot"
            slot-scope="{item}"
          >
            <v-row>
              <v-col
                cols="6"
                class=" mt-3"
              >
                <div class="header-text font-weight-bold">
                  {{ local.requestReply.reasons }}
                </div>
                <div class="info-item-details-value">
                  <ul v-if="(item.requestReplies || []).length">
                    <li
                      v-for="reply in item.requestReplies"
                      :key="reply.id"
                    >
                      <ul style="list-style-type: disc; padding: 20px;">
                        <li
                          v-for="detail in reply.details"
                          :key="detail"
                          class="text-danger"
                        >
                          {{ detail }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </v-col>
            </v-row>
          </template>
          <template
            slot="requestStatusName"
            slot-scope="{item}"
          >
            <div class="info-item-details-title">
              {{ local.home.tabCommon.requestStatus }}
            </div>
            <div
              class="info-item-details-value column-style mt-3"
              :class="item.columnsStyles?item.columnsStyles.requestStatusName:''"
            >
              {{ item.requestStatusName }}
            </div>
          </template>
          <template
            slot="action"
            slot-scope="{item , index}"
          >
            <div class="mx-4">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <router-link :to="`/lawsuit-requests/${item.objectKey}`">
                        <naj-button
                          text
                          type="button"
                          size="small"
                        >
                          {{ local.common.show }}
                        </naj-button>
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.requestStatusId === requestStatusEnum.waitingPartiesAuthentications && !isUserFromMOH">
                    <v-list-item-title>
                      <router-link :to="`/lawsuit-requests/${item.objectKey}/party-authentications`">
                        <naj-button
                          text
                          type="button"
                          size="small"
                        >
                          {{ local.common.authentication }}
                        </naj-button>
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.requestStatusId === requestStatusEnum.NotCompleted || item.requestStatusId === requestStatusEnum.saved || item.requestStatusId === requestStatusEnum.canceledForNotBeingReviewd
                      || item.requestStatusId === requestStatusEnum.canceledFromApplicant
                    ">
                    <v-list-item-title>
                      <naj-button
                        size="small"
                        text
                        :tooltip-message="local.home.tabCommon.requestLogTooltip"
                        @click="handleOpenRecordModel(item.objectKey)"
                      >
                        {{ local.home.tabCommon.requestLog }}
                      </naj-button>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.requestStatusId == requestStatusEnum.draft || item.requestStatusId === requestStatusEnum.NotCompleted || item.requestStatusId === requestStatusEnum.new || item.requestStatusId === requestStatusEnum.returnToAudit">
                    <v-list-item-title>
                      <naj-button
                        color="error"
                        text
                        type="button"
                        size="small"
                        @click="removeItem(index,item.requestStatusId)"
                      >
                        {{ local.common.cancel }}
                      </naj-button>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
        </naj-item-table>
      </v-col>
      <v-col
        v-if="showFilter"
        cols="3"
      >
        <v-card color="pa-3">
          <v-row>
            <v-col class="pt-0">
              <div class="text-left">
                <v-icon
                  class="icon"
                  @click="toggleFilter()"
                >
                  mdi-close
                </v-icon>
              </div>
              <div class="text-h4 font-weight-bold">
                {{ local.common.filter }}
              </div>
            </v-col>
            <v-col
              v-for="filter in filters"
              :key="filter.name"
              cols="12"
            >
              <naj-input
                :type-id="filter.typeId"
                :label="filter.label"
                :value.sync="searchQuery[filter.name]"
                :value-name.sync="searchQuery[filter.name+'DisplayName']"
                :items="filter.items"
                item-text="name"
                item-value="id"
              ></naj-input>
            </v-col>

            <v-col
              cols="12"
              class="text-center"
            >
              <naj-button
                :loading="loading"
                @click="filterData()"
              >
                {{ local.common.filter }}
              </naj-button>

              <naj-button
                outlined
                @click="toggleFilter()"
              >
                {{ local.common.close }}
              </naj-button>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <naj-confirmation
      :show-modal="showRemovePopup"
      color="error"
      :title="local.common.cancelConfirmation"
      :message="local.common.cancelConfirmationMessage"
      :ok-btn-label="local.common.cancel"
      @ok="removeConfirmed"
      @cancel="showRemovePopup = false"
    ></naj-confirmation>
    <naj-confirmation
      :show-modal="showVacationModal"
      :title="vacationModal.title"
      :message="vacationModal.message"
      :close-btn-label="local.common.close"
      @cancel="showVacationModal = false"
    ></naj-confirmation>

    <request-records-modal
      :request-object-key="activeRequestRecords"
      :modal-visibility.sync="recordsModal[activeRequestRecords]"
      @onClose="handleCloseRecordModel(activeRequestRecords)"
    >
    </request-records-modal>
    <request-notes-modal
      :form-model="formModel"
      :modal-visibility="showRequestNotesModal"
      @onCloseRequestNotesModal="handleCloseRequestNotesModel()"
    >
    </request-notes-modal>
  </div>
</template>
<script>

import { requestStatus, requestReplyTypes, userType } from '@/helpers/enum';
import RequestRecordsModal from '@/modules/lawsuit/components/request-records-modal';
import RequestNotesModal from '@/modules/lawsuit/components/request-reasons/request-notes.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('GlobalModule');
const { mapActions: mapLawsuitActions } = createNamespacedHelpers('LawsuitModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);
import { toHijriDate, truncateText } from '@/helpers/utils';

export default {
  name: 'LawsuitTab',
  components: {
    RequestRecordsModal,
    RequestNotesModal,
  },
  data() {
    return {
      formModel: {},
      showRequestNotesModal: false,
      user: null,
      requestStatusEnum: requestStatus,
      loading: false,
      showFilter: false,
      searchQuery: {
        courtId: null,
        fromRequestDate: null,
        toRequestDate: null,
        requestStatusId: null,
        requestCode: null,
      },
      data: { list: [] },
      headers: [
        {
          value: 'requestCode',
          text: this.local.home.tabCommon.requestCode,
          isCustomTemplate: true,
          to: (item) => {
            return {
              name: 'edit-lawsuit-requests',
              params: { objectKey: item.objectKey },
            };
          },
          class: 'requestCode-header',
        },
        {
          value: 'courtName',
          text: this.local.home.tabCommon.courtName,
        },
        {
          value: 'caseTypeName',
          text: this.local.home.tabCommon.requestType,
        },
        {
          value: 'prosecutorName',
          text: this.local.home.tabCommon.prosecutorName,
        },
        {
          value: 'defendantName',
          text: this.local.home.tabCommon.defendantName,
          formatter: truncateText,
        },
        {
          value: 'requestDate',
          text: this.local.home.tabCommon.requestDate,
          formatter: toHijriDate,
        },
        {
          value: 'requestStatusName',
          isCustomTemplate: true,
          class: 'status-item',
        },
        {
          value: 'action',
          isCustomTemplate: true,
          class: 'action-item',
        },
      ],
      pagination: {
        pageSize: 20,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      showRemovePopup: false,
      selectedIndexToDelete: null,
      activeRequestRecords: null,
      recordsModal: {},
      showVacationModal: false,
      vacationModal: {
        title: null,
        message: null,
      },
    };
  },
  computed: {
    filters() {
      return [
        this.mapFilterItem('courtId', 'court', 'selectbox', this.courts),
        this.mapFilterItem('requestStatusId', 'requestStatus', 'selectbox', this.portalRequestStatus),
        this.mapFilterItem('fromRequestDate', 'fromDate', 'date'),
        this.mapFilterItem('toRequestDate', 'toDate', 'date'),
      ];
    },
    ...mapLUTState(['courts', 'portalRequestStatus']),
    hasFilter() {
      return this.searchQuery.courtId ||
        this.searchQuery.fromRequestDate ||
        this.searchQuery.toRequestDate ||
        this.searchQuery.requestStatusId;
    },
    computedSearchQuery() {
      return Object.assign({}, this.searchQuery);
    },
    isUserFromMOH() {
      if (this.user && this.user.userType !== userType.healthAffairs) {
        return this.user.userType === userType.MOHComplianceManagement;
      }
      return true;
    },
  },
  watch: {
    computedSearchQuery: {
      deep: true,
      handler(newValue, oldValue) {
        const oldValueString = JSON.stringify({
          ...oldValue,
          requestCode: null,
        });
        const newValueString = JSON.stringify({
          ...newValue,
          requestCode: null,
        });
        const isChanged = oldValueString != newValueString;
        if (isChanged) {
          this.filterData();
        }
      },
    },
  },
  mounted() { this.init(); },
  methods: {
    mapFilterItem(name, key, typeId, items = []) {
      return {
        name: name,
        label: this.local.home.filter[key],
        typeId: this.formFieldType[typeId],
        items,
      };
    },

    hasDetails(item) {
      return (item.requestReplies || []).length > 0 && (item.requestReplies[0]).detailsCount > 0;
    },
    getRequestReplies(item, index) {
      if (!this.data.list.loaded) {
        this.getCasePreviousReplies({
          objectKey: item.objectKey,
          isCourtsRequestPreviousReplies: false,
        }).then((res) => {
          if (res.data) {
            const requestRepliesWithTypes = res.data.filter(x => x.requestReply == requestReplyTypes.NotCompleted.id ||
              x.requestReply == requestReplyTypes.RequestNotAvailable.id ||
              x.requestReply == requestReplyTypes.PreviousLawsuitOnTheSameSubject.id ||
              x.requestReply == requestReplyTypes.PreviousRequestOnTheSameSubject.id ||
              x.requestReply == requestReplyTypes.SaveRequest.id
            );
            this.$set(this.data.list[index], 'requestReplies',
              [requestRepliesWithTypes[requestRepliesWithTypes.length - 1]]);
          }
        });
      }
    },
    toggleFilter() {
      this.showFilter = !this.showFilter;
    },
    ...mapLUTActions(['getCourts', 'getPortalRequestStatus']),
    ...mapActions(['getRequests', 'getUserInfo']),
    ...mapLawsuitActions(['submitCaseReply', 'getCasePreviousReplies']),
    init() {
      this.pagination.pageIndex = 0;
      this.searchQuery.requestCode = null;
      this.loadData();
      this.getCourts();
      this.getPortalRequestStatus();
      this.getUserInfo().then((u) => {
        this.user = u;
      });
    },
    loadData() {
      this.loading = true;
      this.getRequests({
        ...this.searchQuery,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.data.list = data.list.map((item) => {
            return {
              ...item,
              expandBasedOnCondition: item.requestStatusId == this.requestStatusEnum.NotCompleted ||
                item.requestStatusId === this.requestStatusEnum.previousLawsuitOnTheSameSubject ||
                item.requestStatusId === this.requestStatusEnum.previousRequestOnTheSameSubject ||
                item.requestStatusId === this.requestStatusEnum.requestNotAvailable ||
                item.requestStatusId === this.requestStatusEnum.saved,
            };
          });
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
          this.$emit('updateTabCount', this.pagination.totalCount);
        });
    },
    onPageChange(pageIndex) {
      this.pagination.pageIndex = pageIndex - 1;
      this.loadData();
    },
    filterData() {
      this.pagination.pageIndex = 0;
      this.loadData();
    },
    removeItem(index, requestStatusId) {
      if (requestStatusId === this.requestStatusEnum.new || requestStatusId === this.requestStatusEnum.returnToAudit) {
        this.formModel.rowIndex = index;
        this.showRequestNotesModal = true;
      } else {
        this.showRemovePopup = true;
        this.showRequestNotesModal = false;
        this.selectedIndexToDelete = index;
      }
    },
    removeConfirmed() {
      const request = this.data.list[this.selectedIndexToDelete];
      const apiRequestBody = {
        requestObjectKey: request.objectKey,
        requestReply: this.formModel.reason ? requestReplyTypes.CancelRequestByApplicant.id : requestReplyTypes.CancelRequest.id,
        reasons: this.formModel.reason ? [this.formModel.reason] : [this.local.caseReply.cancelReasons],
        disableRedirect: true,
      };
      this.submitCaseReply(apiRequestBody).then(() => {
        this.toaster.success(`تم ${requestReplyTypes.CancelRequest.name}`);
        this.loadData();
      })
        .finally(() => {
          this.selectedIndexToDelete = null;
          this.showRequestNotesModal = false;
          this.showRemovePopup = false;
          this.formModel.reason = null;
        });
    },
    handleCloseRequestNotesModel() {
      if (this.formModel.reason) {
        this.showRemovePopup = true;
        this.selectedIndexToDelete = this.formModel.rowIndex;
      } else {
        this.showRequestNotesModal = false;
        this.showRemovePopup = false;
      }
    },
    handleOpenRecordModel(objectKey) {
      this.activeRequestRecords = objectKey;
      this.recordsModal = {
        ...this.recordsModal,
        [objectKey]: true,
      };
    },
    handleCloseRecordModel(objectKey) {
      this.activeRequestRecords = null;
      this.recordsModal = {
        ...this.recordsModal,
        [activeRequestRecords]: false,
      };
    },
  },
};
</script>

	<style lang="scss" scoped>
::v-deep .v-input__prepend-inner {
  transform: scale(1, 1);
}
::v-deep .List__empty {
  margin-top: 0px !important;
}

.column-style {
  color: #333;
  &.default-state {
    color: #a3a3a3;
  }
  &.transfered-reconciliation {
    color: #7f9bc2;
  }
  &.registered {
    color: #94867d;
  }
  &.completed {
    color: #0db55d;
  }
  &.accepted-from-audit {
    color: #6ab685;
  }
  &.under-review {
    color: #b5740d;
  }
  &.canceled {
    color: #f68887;
  }
  &.transfered-subcircle {
    color: #94b4ae;
  }
  &.not-completed {
    color: #db4a4a;
  }

  &.request-not-available {
    color: #db4a4a;
  }
  &.previous-request-same-subject {
    color: #db4a4a;
  }
  &.previous-case-same-subject {
    color: #db4a4a;
  }
  &.new {
    color: #a1a1a1;
  }
  &.canceled-not-reviewed {
    color: #f68887;
  }
  &.case-corona {
    background: transparent;
    color: #db4a4a;
    border-color: #db4a4a;
    &:after {
      display: inline-block;
      font: normal normal normal 24px/1 'Material Design Icons';
      content: '\F13B6';
    }
  }
}

.filter-row-wrapper {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 30px #d1d5df80;
}

::v-deep .v-chip.v-chip--outlined.v-chip.v-chip {
  background-color: #f7fbfb !important;
  border: 1px solid var(--app-primary-color) !important;
  border-radius: unset;

  .v-chip__content {
    button {
      color: var(--app-primary-color);
    }
  }
}

::v-deep .info-item-details.requestCode-header {
  .info-item-details-value {
    font-size: 24px;
  }
}
</style>
